(function () {
  //customizations :

  // Partie commune de setupPerso (sans lettres) - exécutée quand la grille existe
  function setupPersoBase() {
    if (window.matchMedia("(max-width: 980px)").matches) {
      const desc = document.querySelector(".read-more-btn");
      const titre = document.querySelector(".product__title-and-price");
      const container = document.querySelector(".product-single__media-slider");
      const grille = document.querySelector(".product-personalizer");

      if (!titre || !container || !grille) return;

      titre.style = "transform:translateY(-20px) !important;";
      container.insertAdjacentElement("beforeBegin", titre);

      if (desc && titre.querySelector(".breadcrumbs")) {
        desc.insertAdjacentElement(
          "afterEnd",
          titre.querySelector(".breadcrumbs"),
        );
      }
    }
  }

  // Partie spécifique aux lettres - exécutée uniquement quand les lettres existent
  function setupPersoWithLetters(isCustom) {
    const garanties = document.querySelectorAll(
      ".product__block:nth-child(11),.product__block:nth-child(12)",
    );
    garanties?.forEach((element) => {
      element.style.display = "none";
    });
    if (window.matchMedia("(max-width: 980px)").matches) {
      const container = document.querySelector(".product-single__media-slider");
      const grille = document.querySelector(".product-personalizer");

      if (!container || !grille) return;

      if (!isCustom) {
        let alleledm = document.querySelectorAll(
          ".pplr-lettre-gauche .pplr_thumb_image .pplrimage:not(.pplr_deselect)",
        );

        // perso gravure
        if (!alleledm.length) {
          document
            .querySelector(".product__form__wrapper")
            .insertAdjacentElement("beforeBegin", grille);
          document.querySelector(".breadcrumbs").style.marginBottom = "20px";
        } else {
          container.insertAdjacentElement("beforeEnd", grille);
        }
      } else {
        grille.style.display = "flex";
        grille.style.flexDirection = "column";
        container.insertAdjacentElement("beforeEnd", grille);
      }
    }
  }

  function setupMobileKeyboardCloseScroll() {
    if (!window.matchMedia("(max-width: 980px)").matches) return;

    const scrollSliderToTop = () => {
      const slider = document.querySelector(".product-single__media-slider");
      if (!slider) return;
      slider.scrollTop = 0;
      if (typeof slider.scrollTo === "function") {
        slider.scrollTo({ top: 0, behavior: "auto" });
      }
      slider.scrollIntoView({ block: "center" });
    };

    const onViewportResize = (getHeight) => {
      let lastHeight = getHeight();
      return () => {
        const currentHeight = getHeight();
        const heightDelta = currentHeight - lastHeight;
        lastHeight = currentHeight;

        if (heightDelta > 150) {
          scrollSliderToTop();
        }
      };
    };

    if (window.visualViewport) {
      const handler = onViewportResize(() => window.visualViewport.height);
      window.visualViewport.addEventListener("resize", handler);
    } else {
      const handler = onViewportResize(() => window.innerHeight);
      window.addEventListener("resize", handler);
    }
  }

  // Fonction pour attendre que les classes de charms existent
  function waitForCharmsClasses(onFound, onTimeout) {
    let attempts = 0;
    const maxAttempts = 10;
    const checkInterval = setInterval(() => {
      const hasCharmsClasses =
        document.querySelector(".pplr-lettre-gauche") ||
        document.querySelector(".pplr-lettre-centre") ||
        document.querySelector(".pplr-lettre-droite");

      if (hasCharmsClasses) {
        clearInterval(checkInterval);
        onFound();
      } else if (++attempts >= maxAttempts) {
        clearInterval(checkInterval);

        onTimeout();
      }
    }, 1000);
  }

  // Fonction pour initialiser l'interface des charms
  function initializeCharmsUI(target) {
    const html = `
        <style>
          .popup-overlay {
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0,0,0,0.5); display: none;
            justify-content: center; align-items: center; z-index: 9999;
          }
          .popup-content {
            background: white; padding: 20px;
            border-radius: 8px; max-height: 80vh; overflow-y: auto;
            max-width: 90%;
          }
          .thumbnail-grid .rk_popimg {
            width: 12.5%; cursor: pointer;
            display:inline-block;
          }
          .selected-zone {
            display: flex; gap: 10px; margin-top: 10px; flex-wrap: wrap;
          }
          .selected-img-wrapper {
            position: relative; cursor: move;
          }
          .selected-img-wrapper img:not(.remove-btn) {
            width: 80px; height: auto;
          }
          .remove-btn {
            position: absolute; top: -6px; right: -6px;
            border-radius: 50%; font-size: 12px;
            width: 30px; height: 30px; cursor: pointer;
          }
          .rk_filtresPop {
                margin: 10px 0 20px;
            }
                      .rk_filtresPop label {
                border:solid 1px  #DCA59A;
                padding:5px;
                border-radius: 10px;
                color: #DCA59A;
                margin-right: 10px;
            transition: all .4s;
            }

            .rk_filtresPop label:hover {
                background: #DCA59A;
            color: white;
            cursor: pointer;

            }


            .rk_filtresPop input[type='radio'] {
              -webkit-appearance: none;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              outline: none;
              box-shadow: 0 0 0 1px #DCA59A;
                position: relative;
            }
            .product-single__details .form__wrapper {
                display: flex;
                flex-direction: column;
                width: 100%;

            }

            .rk_filtresPop input[type='radio']:checked {
              box-shadow: 0 0 0 1px #DCA59A;
            }

            .rk_filtresPop input[type='radio']:before {
              content: '';
              display: block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
            transform: translate(-50%,-50%);
            }
       .charms > *:nth-child(-n+160){
    display: none;
}

.lettre > *:nth-child(n+161) {
    display: none;
}

            .popup-overlay .popup-content{
            width:90%;
            max-width:1080px;
            }
            input[type='radio']:checked:before {
              background: #DCA59A;
            }
            .rk_popimg span {
            width: 100%;
            display:block;
            margin-bottom:10px;
            text-align:center;
            }

                    @media screen and (max-width: 720px) {
                    .pplrabs {
                    position:relative !important;
                    }
              .thumbnail-grid .rk_popimg {
              width: 33% !important;
            }  
            }
            .popup-content button{
            color: #DCA59A;
            margin-bottom:20px;
            }
            </style>

        <div id="image-select-container" style="display:flex;flex-wrap:wrap;">
        <div class="selected-zone 1" id="selected-images">
          <button id="open-popup"><img style="width:100px; height:100px;" src="https://cdn.shopify.com/s/files/1/0831/2163/5652/files/btn_ajouter_charm.svg?v=1751032280" /></button>
        
        </div>
          
        </div>

      
      `;
    target.insertAdjacentHTML("afterbegin", html);

    const overlay = `  <div class="popup-overlay" id="image-popup">
          <div class="popup-content">
            <button onclick="document.getElementById('image-popup').style.display = 'none'">Fermer</button>
              <div class="rk_filtresPop">
          
            
          <label for="filtreLettres">
                <input onchange="filterPop('Charms')" type="radio" id="filtreLettres" name="filtres" value="Charms"  />
                Charms</label>
          <label for="filtreCharms">
                <input onchange="filterPop('Lettre')" type="radio" id="filtreCharms" name="filtres" value="Lettres" />
                Lettres</label>
              </div>
            <div class="thumbnail-grid" id="popup-thumbnails"></div>
          </div>
        </div>`;
    document.querySelector("main").insertAdjacentHTML("beforeend", overlay);

    const popup = document.getElementById("image-popup");
    const popupThumbnails = document.getElementById("popup-thumbnails");
    const selectedZone = document.getElementById("selected-images");
    const addBtn = document.getElementById("open-popup");
    const defautCharms = document
      .querySelector(".product__block")
      .getAttribute("data-defautcharms");
    if (defautCharms !== "vide") {
      const spanElement = document.querySelector(
        `span[data-val="${defautCharms}"]`,
      );

      if (spanElement) {
        addImage(spanElement.getAttribute("data-image"), true);
      }
    }
    let alleledm = document.querySelectorAll(
      ".pplr-lettre-gauche .pplr_thumb_image .pplrimage:not(.pplr_deselect)",
    );

    // perso gravure
    if (!alleledm.length) {
      const popuphide = document.getElementById("image-select-container");
      popuphide.style.display = "none";

      const draggableDiv = document.querySelector("div.is-draggable");
      document.querySelector(".pplr-font-select").style.display = "block";
      if (draggableDiv) {
        // Créer la nouvelle div
        const disableScrollDiv = document.createElement("div");
        disableScrollDiv.className = "rk_disableScroll";

        // Ajouter la nouvelle div à la fin du parent
        draggableDiv.appendChild(disableScrollDiv);
      }
    }

    addBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      popup.style.display = "flex";

      // Masquer les filtres pendant le chargement
      const filtresPop = document.querySelector(".rk_filtresPop");
      filtresPop.style.display = "none";

      // Afficher un loader dans la popup
      popupThumbnails.innerHTML =
        '<div style="display: flex; justify-content: center; align-items: center; min-height: 200px; width: 100%;"><div style="text-align: center;">Chargement des charms...</div></div>';

      const MAX_WAIT = 2000; // ms
      const INTERVAL = 100; // ms
      let waited = 0;

      // Reusable fill function
      function fillThumbnails(allelem) {
        popupThumbnails.innerHTML = "";
        const allelemArr = Array.from(allelem);

        const hasLettres = allelemArr
          .slice(0, 156)
          .some(
            (el) =>
              !el.classList.contains("vrdisabled") &&
              el.getAttribute("data-tag") !== "novisible" &&
              el.getAttribute("data-image"),
          );
        const hasCharms = allelemArr
          .slice(156)
          .some(
            (el) =>
              !el.classList.contains("vrdisabled") &&
              el.getAttribute("data-tag") !== "novisible" &&
              el.getAttribute("data-image"),
          );

        const filtresPop = document.querySelector(".rk_filtresPop");
        if (!hasCharms || !hasLettres) {
          filtresPop.style.display = "none";
          popupThumbnails.classList.remove("lettre", "charms");
          if (!hasCharms) popupThumbnails.classList.add("lettre");
          if (!hasLettres) popupThumbnails.classList.add("charms");
        } else {
          filtresPop.style.display = "";
          popupThumbnails.classList.remove("lettre", "charms");
        }

        allelem.forEach((el) => {
          if (
            el.classList.contains("vrdisabled") ||
            el.getAttribute("data-tag") === "novisible"
          ) {
            const span = document.createElement("span");
            popupThumbnails.appendChild(span);
          } else {
            const url = el.getAttribute("data-image");
            const price = el.getAttribute("data-pplr_price");
            if (url) {
              const div = document.createElement("div");
              div.classList.add("rk_popimg");
              const img = document.createElement("img");
              const span = document.createElement("span");
              span.textContent = "CHF " + price;

              img.src = url;
              img.onclick = () => addImage(url);
              div.appendChild(img);
              div.appendChild(span);
              popupThumbnails.appendChild(div);
            }
          }
        });

        if (hasCharms && hasLettres) {
          const charmsFilter = document.querySelector("#filtreLettres");
          if (charmsFilter) {
            charmsFilter.checked = true;
          }
          filterPop("Charms");
        }
      }
  let testElement = document.querySelector(
          '.pplr-lettre-gauche .pplr_thumb_image .pplrimage[data-val="charm-petit-garcon-zircons-v2"]',
        );
        if (testElement == null) {
          testElement = document.querySelector(
          '.pplr-lettre-tout-droite .pplr_thumb_image .pplrimage[data-val="__Charm-dore-zircons-lettre-M"]',
        );
        }
      const iv = setInterval(() => {
        // Vérifier spécifiquement l'élément charm-petit-garcon-zircons-v2
      
        
        const isReady =
          testElement && testElement.classList.contains("vrdisabled");

        // Si l'élément test a la classe vrdisabled, on considère que la liste est prête
        if (isReady || waited >= MAX_WAIT) {
          clearInterval(iv);

          const allelem = document.querySelectorAll(
            ".pplr-lettre-gauche .pplr_thumb_image .pplrimage:not(.pplr_deselect)",
          );

          if (!allelem || allelem.length === 0) {
            // fallback: tente de récupérer encore une fois
            const fallback = document.querySelectorAll(
              ".pplr-lettre-gauche .pplr_thumb_image .pplrimage:not(.pplr_deselect)",
            );
            fillThumbnails(fallback);
            return;
          }
          fillThumbnails(allelem);
        } else {
          waited += INTERVAL;
        }
      }, INTERVAL);
    });

    function addImage(url, isDefault = false) {
      let loader = document.querySelector(".rk_loadingCharms");
      if (loader) {
        loader.classList.add("loading");
      }
      // Récupère la valeur de l'attribut data-maxcharms et la convertit en nombre
      const maxCharms = parseInt(
        document
          .querySelector(".product__block")
          .getAttribute("data-maxcharms"),
        10,
      );

      if (selectedZone.children.length >= maxCharms + 1) return;
      const wrapper = document.createElement("div");
      wrapper.className = "selected-img-wrapper";
      wrapper.setAttribute("draggable", true);

      const img = document.createElement("img");
      img.src = url;
      wrapper.appendChild(img);

      if (!isDefault) {
        const remove = document.createElement("img");
        remove.className = "remove-btn";
        remove.src =
          "https://cdn.shopify.com/s/files/1/0831/2163/5652/files/btn_supprimer_charm.svg?v=1751032971";
        remove.onclick = () => {
          let loader = document.querySelector(".rk_loadingCharms");
          if (loader) {
            loader.classList.add("loading");
          }
          wrapper.remove();

          // Petite pause pour laisser le DOM se mettre à jour
          setTimeout(() => {
            Array.from(document.querySelectorAll(".pplr_deselect"))
              .filter(
                (btn) =>
                  !btn.closest(
                    ".pplr-wrapper.pplr--colliersperso, .pplr-wrapper.pplr-colliersperso, .pplr-wrapper.pplr-cordonsperso",
                  ),
              )
              .forEach((btn) => btn.click());

            setTimeout(() => {
              applyImageAssignments();
              // updateCharmsProperties(); // Synchroniser avec le formulaire
            }, 100);
          }, 100);
        };
        wrapper.appendChild(remove);
      }

      selectedZone.appendChild(wrapper);
      selectedZone.insertBefore(wrapper, addBtn);
      enableDragDrop();
      applyImageAssignments();
      // updateCharmsProperties(); // Synchroniser avec le formulaire
      popup.style.display = "none";
    }

    function enableDragDrop() {
      let dragged;

      document.querySelectorAll(".selected-img-wrapper").forEach((item) => {
        item.addEventListener("dragstart", (e) => {
          dragged = item;
          e.dataTransfer.effectAllowed = "move";
        });

        item.addEventListener("dragover", (e) => {
          e.preventDefault();
          item.style.border = "2px dashed #333";
        });

        item.addEventListener("dragleave", () => {
          item.style.border = "none";
        });

        item.addEventListener("drop", (e) => {
          e.preventDefault();
          if (dragged && dragged !== item) {
            selectedZone.insertBefore(dragged, item);

            // Reset + réaffectation
            Array.from(document.querySelectorAll(".pplr_deselect"))
              .filter(
                (btn) =>
                  !btn.closest(
                    ".pplr-wrapper.pplr--colliersperso, .pplr-wrapper.pplr-colliersperso, .pplr-wrapper.pplr-cordonsperso",
                  ),
              )
              .forEach((btn) => btn.click());

            setTimeout(() => {
              applyImageAssignments();
            }, 100);
          }
          item.style.border = "none";
        });
      });
    }

    function applyImageAssignments() {
      const selectedImages = selectedZone.querySelectorAll(
        ".selected-img-wrapper",
      );
      const count = selectedImages.length;

      // 1. Deselect uniquement les slots de charms (pas les chaînes/cordons)
      Array.from(document.querySelectorAll(".pplr_deselect"))
        .filter(
          (btn) =>
            !btn.closest(
              ".pplr-wrapper.pplr--colliersperso, .pplr-wrapper.pplr-colliersperso, .pplr-wrapper.pplr-cordonsperso",
            ),
        )
        .forEach((btn) => btn.click());

      // 2. Affectation conditionnelle
      let targets = [];
      if (count === 1) {
        targets = [
          document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),
        ];
      } else if (count === 2) {
        if (document.querySelector(".pplr-tmplcraxelle")) {
          targets = [
            document.querySelector(".pplr-lettre-gauche .pplr_thumb_image"),
            document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),
          ];
        } else {
          targets = [
            document.querySelector(
              ".pplr-lettre-gauche-centre .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-droite-centre .pplr_thumb_image",
            ),
          ];
        }
      } else if (count === 3) {
        targets = [
          document.querySelector(".pplr-lettre-gauche .pplr_thumb_image"),
          document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),
          document.querySelector(".pplr-lettre-droite .pplr_thumb_image"),
        ];
      } else if (count === 4) {
        if (document.querySelector(".pplr-tmplcraxelle")) {
          targets = [
            document.querySelector(
              ".pplr-lettre-tout-gauche .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-gauche-centre .pplr_thumb_image",
            ),
            document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),
            document.querySelector(
              ".pplr-lettre-droite-centre .pplr_thumb_image",
            ),
          ];
        } else {
          targets = [
            document.querySelector(
              ".pplr-lettre-tout-gauche .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-gauche-centre .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-droite-centre .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-tout-droite .pplr_thumb_image",
            ),
          ];
        }
      } else if (count === 5) {
        if (document.querySelector(".pplr-tmplcraxelle")) {
          targets = [
            document.querySelector(
              ".pplr-lettre-tout-gauche .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-gauche-centre .pplr_thumb_image",
            ),
            document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),

            document.querySelector(
              ".pplr-lettre-droite-centre .pplr_thumb_image",
            ),
            document.querySelector(
              ".pplr-lettre-tout-droite .pplr_thumb_image",
            ),
          ];
        } else {
          targets = [
            document.querySelector(
              ".pplr-lettre-tout-tout-gauche .pplr_thumb_image",
            ),
            document.querySelector(".pplr-lettre-gauche .pplr_thumb_image"),
            document.querySelector(".pplr-lettre-centre .pplr_thumb_image"),
            document.querySelector(".pplr-lettre-droite .pplr_thumb_image"),
            document.querySelector(
              ".pplr-lettre-tout-tout-droite .pplr_thumb_image",
            ),
          ];
        }
      }

      selectedImages.forEach((img, index) => {
        const url = img.querySelector("img").src;
        const target = targets[index];
        if (target) {
          const match = Array.from(target.querySelectorAll(".pplrimage")).find(
            (el) => el.getAttribute("data-image") === url,
          );
          if (match) {
            match.click();
          }
        }
      });

      // AJOUT : Synchroniser avec le formulaire Shopify
      // updateCharmsProperties();

      let loader = document.querySelector(".rk_loadingCharms");
      if (loader) {
        setTimeout(() => {
          loader.classList.remove("loading");
        }, 2000);
      }
    }

    // NOUVELLE FONCTION : Met à jour les propriétés du formulaire Shopify (charms uniquement)
    function updateCharmsProperties() {
      const form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      // Supprimer les anciens inputs de personnalisation CHARMS uniquement
      form
        .querySelectorAll('input[name^="properties[lettre"]')
        .forEach((input) => input.remove());

      // Récupérer les sélections actuelles
      const selectedImages = document.querySelectorAll(
        ".selected-img-wrapper img:not(.remove-btn)",
      );

      selectedImages.forEach((img, index) => {
        const url = img.src;
        // Trouver l'élément PPLR correspondant pour récupérer les données
        const pplrElement = document.querySelector(`[data-image="${url}"]`);
        if (pplrElement) {
          const charmName =
            pplrElement.getAttribute("data-pplr_text") ||
            pplrElement.getAttribute("alt") ||
            url.split("/").pop().split(".")[0];

          // Déterminer la position (lettre centre, gauche, droite, etc.)
          let position = "centre";
          if (index === 0 && selectedImages.length === 1) position = "centre";
          else if (index === 0) position = "gauche";
          else if (index === 1 && selectedImages.length === 2)
            position = "droite";
          else if (index === 1) position = "centre";
          else if (index === 2) position = "droite";

          // Créer l'input caché
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[lettre ${position}]`;
          input.value = charmName;
          form.appendChild(input);
        }
      });
    }

    setTimeout(() => {
      applyImageAssignments();
      const loaderterget = document.getElementById("pplr_canvas");

      if (loaderterget) {
        const wrapperDiv = document.createElement("div");
        wrapperDiv.classList.add("rk_loadingCharms");
        wrapperDiv.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" data-app="Xyris">
    <defs>
    </defs>
    <text x="-147" y="203" font-family="Arial" font-size="12" fill="#000000" stroke="none">
        
    </text>
    <text x="193.877" y="261.678" font-family="Verdana" font-size="14" fill="rgb(206, 137, 137)" transform="">
        Création en cours
    </text>
    <path d="M 189.856 240.596 C 189.856 240.5 190.143 239.399 190.43 238.106 C 191.436 233.797 192.298 231.067 193.447 228.913 C 196.272 223.645 200.438 221.491 211.595 219.575 C 212.983 219.336 214.133 219.097 214.133 219.049 C 214.133 219.001 212.983 218.761 211.643 218.522 C 203.359 217.085 199.289 215.601 196.464 213.063 C 193.639 210.526 191.867 206.647 190.287 199.321 C 190.047 198.267 189.856 197.31 189.76 197.262 C 189.76 197.214 189.473 198.076 189.233 199.129 C 188.707 201.619 187.941 204.444 187.366 206.024 C 185.977 209.951 184.254 212.345 181.524 214.165 C 180.71 214.691 178.939 215.601 177.694 216.032 C 175.635 216.798 171.66 217.756 167.494 218.474 C 166.297 218.666 165.34 218.905 165.388 218.953 C 165.436 218.953 166.441 219.192 167.638 219.384 C 174.15 220.485 178.508 221.826 181.189 223.454 C 183.009 224.603 184.732 226.375 185.834 228.242 C 187.127 230.541 188.371 234.371 189.425 239.255 C 189.569 239.974 189.712 240.596 189.76 240.596 C 189.76 240.596 189.856 240.548 189.856 240.452 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.00002000000000001" dur="3.2866987417218545" keyTimes="0; 0.08722444882814025; 0.3178243624979269; 0.5442894449842945; 0.7623740981782592; 1" values="0, 0.30000001192092896; 0, 0.30000001192092896; 1, 1; 0.31754644438036483, 0.3; 1, 1; 0, 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.00002000000000001" dur="3.2866987417218545" keyTimes="0; 0.08722444882814025; 0.5442894449842945; 1" values="0; 0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
    <path d="M 249.512 343.467 C 249.512 343.371 249.799 342.27 250.086 340.977 C 251.092 336.668 251.954 333.938 253.103 331.784 C 255.928 326.516 260.094 324.362 271.251 322.446 C 272.639 322.207 273.789 321.968 273.789 321.92 C 273.789 321.872 272.639 321.632 271.299 321.393 C 263.015 319.956 258.945 318.472 256.12 315.934 C 253.295 313.397 251.523 309.518 249.943 302.192 C 249.703 301.138 249.512 300.181 249.416 300.133 C 249.416 300.085 249.129 300.947 248.889 302 C 248.363 304.49 247.597 307.315 247.022 308.895 C 245.633 312.822 243.91 315.216 241.18 317.036 C 240.366 317.562 238.595 318.472 237.35 318.903 C 235.291 319.669 231.316 320.627 227.15 321.345 C 225.953 321.537 224.996 321.776 225.044 321.824 C 225.092 321.824 226.097 322.063 227.294 322.255 C 233.806 323.356 238.164 324.697 240.845 326.325 C 242.665 327.474 244.388 329.246 245.49 331.113 C 246.783 333.412 248.027 337.242 249.081 342.126 C 249.225 342.845 249.368 343.467 249.416 343.467 C 249.416 343.467 249.512 343.419 249.512 343.323 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;" transform="">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.00002" dur="3.0000400000000003" keyTimes="0; 0.25263594470046086; 0.500741935483871; 0.7396666666666666; 1" values="0, 0.30000001192092896; 0.5, 0.5000163040275244; 0.31754644438036483, 0.3; 0.5, 0.5008515531263525; 0, 0.30000001192092896" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.00002" dur="3.0000400000000003" keyTimes="0; 0.500741935483871; 1" values="0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
    <path d="M 258.656 224.066 C 258.656 223.97 258.943 222.869 259.23 221.576 C 260.236 217.267 261.098 214.537 262.247 212.383 C 265.072 207.115 269.238 204.961 280.395 203.045 C 281.783 202.806 282.933 202.567 282.933 202.519 C 282.933 202.471 281.783 202.231 280.443 201.992 C 272.159 200.555 268.089 199.071 265.264 196.533 C 262.439 193.996 260.667 190.117 259.087 182.791 C 258.847 181.737 258.656 180.78 258.56 180.732 C 258.56 180.684 258.273 181.546 258.033 182.599 C 257.507 185.089 256.741 187.914 256.166 189.494 C 254.777 193.421 253.054 195.815 250.324 197.635 C 249.51 198.161 247.739 199.071 246.494 199.502 C 244.435 200.268 240.46 201.226 236.294 201.944 C 235.097 202.136 234.14 202.375 234.188 202.423 C 234.236 202.423 235.241 202.662 236.438 202.854 C 242.95 203.955 247.308 205.296 249.989 206.924 C 251.809 208.073 253.532 209.845 254.634 211.712 C 255.927 214.011 257.171 217.841 258.225 222.725 C 258.369 223.444 258.512 224.066 258.56 224.066 C 258.56 224.066 258.656 224.018 258.656 223.922 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;" transform="">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.000030000000000000004" dur="3.0000600000000004" keyTimes="0; 0.25263594470046086; 0.500741935483871; 0.7396666666666666; 1" values="0, 0.30000001192092896; 0.5, 0.5000163040275244; 0.31754644438036483, 0.3; 0.5, 0.5008515531263525; 0, 0.30000001192092896" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.000030000000000000004" dur="3.0000600000000004" keyTimes="0; 0.500741935483871; 1" values="0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
    <path d="M 330.907 302.899 C 330.907 302.803 331.193 301.702 331.481 300.409 C 332.486 296.1 333.348 293.37 334.498 291.216 C 337.322 285.948 341.489 283.794 352.645 281.878 C 354.033 281.639 355.183 281.4 355.183 281.352 C 355.183 281.304 354.033 281.064 352.693 280.825 C 344.409 279.388 340.339 277.904 337.515 275.366 C 334.689 272.829 332.917 268.95 331.338 261.624 C 331.097 260.57 330.907 259.613 330.81 259.565 C 330.81 259.517 330.524 260.379 330.283 261.432 C 329.757 263.922 328.991 266.747 328.416 268.327 C 327.028 272.254 325.304 274.648 322.575 276.468 C 321.761 276.994 319.989 277.904 318.744 278.335 C 316.685 279.101 312.71 280.059 308.545 280.777 C 307.347 280.969 306.39 281.208 306.438 281.256 C 306.486 281.256 307.491 281.495 308.688 281.687 C 315.2 282.788 319.558 284.129 322.239 285.757 C 324.059 286.906 325.782 288.678 326.884 290.545 C 328.177 292.844 329.421 296.674 330.476 301.558 C 330.619 302.277 330.762 302.899 330.81 302.899 C 330.81 302.899 330.907 302.851 330.907 302.755 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;" transform="">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.000030000000000000004" dur="3.0000600000000004" keyTimes="0; 0.25263594470046086; 0.500741935483871; 0.7396666666666666; 1" values="0, 0.30000001192092896; 0.7, 0.6999896222933131; 0.31754644438036483, 0.3; 0.7, 0.7008100274137655; 0, 0.30000001192092896" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.000030000000000000004" dur="3.0000600000000004" keyTimes="0; 0.500741935483871; 1" values="0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
    <path d="M 184.728 299.082 C 183.816 299.082 183.66 298.359 183.471 297.353 C 182.842 294.274 182.026 291.823 181.238 290.409 C 180.613 289.341 179.638 288.303 178.569 287.643 C 176.936 286.638 174.169 285.821 170.053 285.098 C 168.419 284.815 168.357 284.784 168.168 284.658 L 167.57 284.25 L 167.728 283.527 C 167.885 282.773 168.482 282.678 169.991 282.396 C 172.661 281.924 175.208 281.327 176.495 280.825 C 177.249 280.542 178.319 280.008 178.79 279.694 C 180.392 278.625 181.367 277.242 182.215 274.854 C 182.559 273.88 183.061 272.089 183.407 270.454 C 183.691 269.103 183.816 268.538 184.57 268.381 L 185.074 268.287 L 185.482 268.632 C 185.797 268.884 185.859 269.103 186.173 270.549 C 187.148 275.043 188.216 277.494 189.881 278.97 C 191.578 280.479 194.125 281.39 199.34 282.301 C 201.383 282.678 201.855 282.741 201.855 283.684 C 201.855 284.627 201.414 284.69 199.309 285.067 C 192.332 286.293 189.85 287.549 188.154 290.66 C 187.462 291.98 186.897 293.708 186.268 296.442 L 186.109 297.165 C 185.984 297.73 185.889 298.107 185.859 298.17 L 185.764 298.359 L 185.452 298.924 L 184.728 299.019 Z M 174.138 283.747 C 176.59 284.344 178.38 285.004 179.7 285.821 C 181.083 286.67 182.307 287.958 183.095 289.341 C 183.691 290.377 184.256 291.823 184.76 293.614 C 185.232 291.98 185.672 290.786 186.237 289.718 C 187.934 286.575 190.228 284.972 195.38 283.747 C 192.018 282.962 189.975 282.019 188.436 280.636 C 186.802 279.19 185.702 277.18 184.76 273.88 C 184.57 274.571 184.381 275.168 184.225 275.608 C 183.22 278.405 181.962 280.164 179.984 281.484 C 179.385 281.893 178.161 282.49 177.249 282.836 C 176.495 283.119 175.426 283.432 174.138 283.747 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;" transform="">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.005514505494505494" dur="3.0055345054945057" keyTimes="0; 0.0018314686169181617; 0.2521740904709342; 0.4998265084211117; 0.7401425928110216; 1" values="0, 0; 0, 0; 1, 1; 0.31754644438036483, 0.3; 1, 1; 0, 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.00882576377265119" dur="3.003351258278146" keyTimes="0; 0.0029353284784527558; 0.5001898532336979; 1" values="0; 0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
    <path d="M 323.938 227.7 C 323.026 227.7 322.87 226.977 322.681 225.971 C 322.052 222.892 321.236 220.441 320.448 219.027 C 319.823 217.959 318.848 216.921 317.779 216.261 C 316.146 215.256 313.379 214.439 309.263 213.716 C 307.629 213.433 307.567 213.402 307.378 213.276 L 306.78 212.868 L 306.938 212.145 C 307.095 211.391 307.692 211.296 309.201 211.014 C 311.871 210.542 314.418 209.945 315.705 209.443 C 316.459 209.16 317.529 208.626 318 208.312 C 319.602 207.243 320.577 205.86 321.425 203.472 C 321.769 202.498 322.271 200.707 322.617 199.072 C 322.901 197.721 323.026 197.156 323.78 196.999 L 324.284 196.905 L 324.692 197.25 C 325.007 197.502 325.069 197.721 325.383 199.167 C 326.358 203.661 327.426 206.112 329.091 207.588 C 330.788 209.097 333.335 210.008 338.55 210.919 C 340.593 211.296 341.065 211.359 341.065 212.302 C 341.065 213.245 340.624 213.308 338.519 213.685 C 331.542 214.911 329.06 216.167 327.364 219.278 C 326.672 220.598 326.107 222.326 325.478 225.06 L 325.319 225.783 C 325.194 226.348 325.099 226.725 325.069 226.788 L 324.974 226.977 L 324.662 227.542 L 323.938 227.637 Z M 313.348 212.365 C 315.8 212.962 317.59 213.622 318.91 214.439 C 320.293 215.288 321.517 216.576 322.305 217.959 C 322.901 218.995 323.466 220.441 323.97 222.232 C 324.442 220.598 324.882 219.404 325.447 218.336 C 327.144 215.193 329.438 213.59 334.59 212.365 C 331.228 211.58 329.185 210.637 327.646 209.254 C 326.012 207.808 324.912 205.798 323.97 202.498 C 323.78 203.189 323.591 203.786 323.435 204.226 C 322.43 207.023 321.172 208.782 319.194 210.102 C 318.595 210.511 317.371 211.108 316.459 211.454 C 315.705 211.737 314.636 212.05 313.348 212.365 Z" fill="#ce8989" stroke-width="0px" transform-origin="center" style="transform-box: fill-box;" transform="">
        <animateTransform repeatCount="indefinite" attributeName="transform" type="scale" begin="-0.00002000000000001" dur="3.2900500000000004" keyTimes="0; 0.08814205341592628; 0.3185101471838161; 0.5447475664747836; 0.7626129812392795; 1" values="0, 0; 0, 0; 1, 1; 0.31754644438036483, 0.3; 1, 1; 0, 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
        <animateTransform repeatCount="indefinite" attributeName="transform" type="rotate" begin="-0.00001" dur="3.2900400000000003" keyTimes="0; 0.08713282646362461; 0.5437397240166448; 1" values="0; 0; 180; 0" fill="freeze" additive="sum" calcMode="spline" keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1">
        </animateTransform>
    </path>
</svg>

`;

        loaderterget.parentNode.insertBefore(
          wrapperDiv,
          loaderterget.nextSibling,
        );
      }
    }, 1000);
  }

  (function waitForWrapperAndInject() {
    let attempts = 0;
    const maxAttempts = 10;
    let grilleProcessed = false;
    let charmClassesProcessed = false;

    const interval = setInterval(() => {
      const target = document
        .querySelector(".pplr-wrapper")
        ?.closest(".product__block");
      const grille = document.querySelector(".product-personalizer");
      const hasCharmsClasses =
        document.querySelector(".pplr-lettre-gauche") ||
        document.querySelector(".pplr-lettre-centre") ||
        document.querySelector(".pplr-lettre-droite");

      // Si la grille existe et n'a pas encore été traitée, exécuter setupPersoBase isPerso

      if (grille && !grilleProcessed) {
        setupMobileKeyboardCloseScroll();

        grilleProcessed = true;

        const thumbs = document.querySelector("#ProductThumbs");
        const sliders = document
          .querySelector(".product-single__media-slide")
          ?.closest(".product-single__media-slider");

        if (sliders && document.querySelector(".pplr-wrapper"))
          sliders.classList.add("persocr");
        // if (thumbs) thumbs.classList.add("hidden");

        setupPersoBase();
      }

      // Si les classes de charms existent et n'ont pas encore été traitées
      if (hasCharmsClasses && !charmClassesProcessed) {
        charmClassesProcessed = true;

        if (target) {
          setupPersoWithLetters(false);
          initializeCharmsUI(target);
        }
      }

      // Arrêter après maxAttempts
      if (++attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 1000);
  })();
})();

function filterPop(type) {
  const popupThumbnails = document.getElementById("popup-thumbnails");
  popupThumbnails.className = "thumbnail-grid";
  if (type == "Charms") {
    popupThumbnails.classList.add("charms");
  } else if (type == "Lettre") {
    popupThumbnails.classList.add("lettre");
  }
}
